import { TagType } from '@myre/common-tag';

import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { TagComponent } from '../../tag/tag.component';

import { type CalendarEvent } from '../myre-calendar/myre-calendar.interface';

@Component({
  selector: 'myre-event-calendar-event',
  templateUrl: './myre-event-calendar-event.component.html',
  styleUrls: ['./myre-event-calendar-event.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TagComponent, AsyncPipe],
})
export class MyreEventCalendarEventComponent {
  @Input()
  public event: CalendarEvent;

  public isHover$ = new BehaviorSubject<boolean>(false);

  public get eventTagType(): TagType {
    return this.event?.eventTagType ?? TagType.Secondary;
  }

  @Output()
  public onEventUpdated = new EventEmitter<CalendarEvent>();

  @HostListener('mouseover')
  public onMouseOver(): void {
    this.isHover$.next(true);
  }

  @HostListener('mouseout')
  public onMouseOut(): void {
    this.isHover$.next(false);
  }

  public onEventUpdatedClick(event: CalendarEvent): void {
    this.onEventUpdated.emit(event);
  }
}
